// assets/js/filters/fqBuilder.js
export function buildFq(filter) {
    const fq = [];

    if (filter.dataslug?.length) {
        fq.push(`dataslug:(${filter.dataslug.join(" OR ")})`);
    }

    if (filter.name?.length) {
        fq.push(`name:(${filter.name.map(v => `"${escapeSolr(v)}"`).join(" OR ")})`);
    }
    if (filter.occupation?.length) {
        fq.push(`Occupation:(${filter.occupation.map(v => `"${v}"`).join(" OR ")})`);
    }
    if (filter.birthYear) fq.push(`birthYear:[${filter.birthYear[0]} TO ${filter.birthYear[1]}]`);
    if (filter.deathYear) fq.push(`deathYear:[${filter.deathYear[0]} TO ${filter.deathYear[1]}]`);


    if (filter.birthLocation?.length) {
        fq.push(`birthLocation:(${filter.birthLocation.map(v => `"${escapeSolr(v)}"`).join(" OR ")})`);
    }

    if (filter.deathLocation?.length) {
        fq.push(`deathLocation:(${filter.deathLocation.map(v => `"${escapeSolr(v)}"`).join(" OR ")})`);
    }

    if (filter.birthDate) fq.push(`birthDate:[${filter.birthDate[0]} TO ${filter.birthDate[1]}]`);
    if (filter.deathDate) fq.push(`deathDate:[${filter.deathDate[0]} TO ${filter.deathDate[1]}]`);

    if (filter.birthYear) fq.push(`birthYear:[${filter.birthYear[0]} TO ${filter.birthYear[1]}]`);
    if (filter.deathYear) fq.push(`deathYear:[${filter.deathYear[0]} TO ${filter.deathYear[1]}]`);

    // exists filters
    if (filter.exists?.abstract?.includes("has")) fq.push(`Abstract:[* TO *]`);
    if (filter.exists?.abstract?.includes("missing")) fq.push(`-Abstract:[* TO *]`);

    if (filter.exists?.publication?.includes("has")) fq.push(`Publication:[* TO *]`);
    if (filter.exists?.publication?.includes("missing")) fq.push(`-Publication:[* TO *]`);

    return fq;
}

function escapeSolr(s) {
    // minimal escape for quotes/backslashes
    return String(s).replaceAll("\\", "\\\\").replaceAll('"', '\\"');
}
